const defaultNucleotideColors = {
    "A": "rgb(  0, 200,   0)",
    "C": "rgb(  0,0,200)",
    "T": "rgb(255,0,0)",
    "G": "rgb(209,113,  5)",
    "N": "rgb(80,80,80)"
}

const deuterNucleotideColors = {
    "A": "rgb(34,186,155)",
    "C": "rgb(0,113,178)",
    "T": "rgb(239,63,112)",
    "G": "rgb(254,203,12)",
    "N": "rgb(33,33,33)"
}

const ibmNucleotideColors = {
    "A": "#009E73",
    "C": "#0072B2",
    "T": "#D55E00",
    "G": "#F0E442",
    "N": "rgb(33,33,33)"
}

export {defaultNucleotideColors, deuterNucleotideColors, ibmNucleotideColors}
